import SpaceDashboardOutlinedIcon from "@mui/icons-material/SpaceDashboardOutlined";
import ApartmentOutlinedIcon from "@mui/icons-material/ApartmentOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import BuildOutlinedIcon from "@mui/icons-material/BuildOutlined";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import InsightsOutlinedIcon from "@mui/icons-material/InsightsOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import MailOutlineIcon from "@mui/icons-material/MailOutline";

const companyMenu = [
  {
    path: "/dashboard",
    icon: SpaceDashboardOutlinedIcon,
    label: "Dashboard",
    roles: ["SuperAdmin", "CompanyAdmin", "Staff", "Viewer"],
    guide: "Rent that is due, vacant units, and payments that just came in."
  },
  {
    path: "/assets",
    icon: ApartmentOutlinedIcon,
    label: "Assets",
    roles: ["SuperAdmin", "CompanyAdmin", "Staff", "Viewer"],
    guide: "Each property lives here. The units number is how many spaces it has."
  },
  {
    path: "/asset-owners",
    icon: PersonOutlineOutlinedIcon,
    label: "Asset Owners",
    roles: ["SuperAdmin", "CompanyAdmin", "Staff", "Viewer"],
    guide: "The owner of a property, including the phone number."
  },
  {
    path: "/tenants",
    icon: GroupsOutlinedIcon,
    label: "Tenants",
    roles: ["SuperAdmin", "CompanyAdmin", "Staff", "Viewer"],
    guide: "The people who rent a unit."
  },
  {
    path: "/rentals",
    icon: AssignmentOutlinedIcon,
    label: "Rentals",
    roles: ["SuperAdmin", "CompanyAdmin", "Staff", "Viewer"],
    guide: "A unit, its dalasi rent, and the tenant on the contract."
  },
  {
    path: "/payments",
    icon: PaymentsOutlinedIcon,
    label: "Payments",
    roles: ["SuperAdmin", "CompanyAdmin", "Staff", "Viewer"],
    guide: "Record rent in dalasis. A payment can also be saved in dollars."
  },
  {
    path: "/maintenance",
    icon: BuildOutlinedIcon,
    label: "Maintenance",
    roles: ["SuperAdmin", "CompanyAdmin", "Staff", "Viewer"],
    guide: "A repair, its cost, and whether the work is finished."
  },
  {
    path: "/users",
    icon: GroupOutlinedIcon,
    label: "Users",
    roles: ["SuperAdmin", "CompanyAdmin"],
    guide: "People who can sign in for this company."
  },
  {
    path: "/invoice",
    icon: ReceiptLongOutlinedIcon,
    label: "Invoice",
    roles: ["SuperAdmin", "CompanyAdmin", "Staff", "Viewer"],
    guide: "A printed bill for the dalasi rent a tenant still owes."
  },
  {
    path: "/reports",
    icon: InsightsOutlinedIcon,
    label: "Reports",
    roles: ["SuperAdmin", "CompanyAdmin"],
    guide: "Daily, monthly, and owner summaries."
  },
  {
    path: "/imports",
    icon: UploadFileOutlinedIcon,
    label: "Import & Export",
    roles: ["SuperAdmin", "CompanyAdmin", "Staff"],
    guide: "Bring records in from a file, or download the ones you have."
  },
  {
    path: "/messages",
    icon: MailOutlineIcon,
    label: "Messages",
    roles: ["SuperAdmin", "CompanyAdmin", "Staff", "Viewer"],
    guide: "Notes sent between people in the company."
  },
  {
    path: "/company-settings",
    icon: SettingsOutlinedIcon,
    label: "Company Settings",
    roles: ["SuperAdmin", "CompanyAdmin"],
    guide: "The company name, logo, phone, and address shown on invoices."
  }
];

const superAdminMenu = [
  {
    path: "/superadmin",
    icon: SpaceDashboardOutlinedIcon,
    label: "Dashboard",
    guide: "Companies, users, and how the platform is doing."
  },
  {
    path: "/superadmin/companies",
    icon: BusinessOutlinedIcon,
    label: "Companies",
    guide: "Open a company and its subscription."
  },
  {
    path: "/superadmin/subscriptions",
    icon: PaymentsOutlinedIcon,
    label: "Subscriptions",
    guide: "The plans and their prices in dalasis."
  },
  {
    path: "/messages",
    icon: MailOutlineIcon,
    label: "Messages",
    guide: "Messages with a company or another administrator."
  },
  {
    path: "/users",
    icon: GroupOutlinedIcon,
    label: "System Administrators",
    guide: "People who manage the whole platform."
  },
  {
    path: "/superadmin/company-users",
    icon: GroupsOutlinedIcon,
    label: "Company Users",
    guide: "People who sign in for each company."
  },
  {
    path: "/reports",
    icon: InsightsOutlinedIcon,
    label: "Platform Reports",
    guide: "Reports across all companies."
  },
  {
    path: "/imports",
    icon: UploadFileOutlinedIcon,
    label: "Import & Export",
    guide: "Bring records in from a file, or download them."
  },
  {
    path: "/superadmin/settings",
    icon: SettingsOutlinedIcon,
    label: "System Settings",
    guide: "The public site name and how companies should pay."
  }
];

export const getMenuItems = (role) => (
  role === "SuperAdmin"
    ? superAdminMenu
    : companyMenu.filter((item) => item.roles.includes(role))
);

export const guideStorageKey = (user) => {
  const id = user?.id || user?.email;
  return id ? `gamrent-guide-seen:${id}` : "";
};
